import createServe from "@/utils/http"

//获取当前ip
export let getCurrentIp = (params = {}) => {
    return createServe({
        method: "GET",
        url: "/getCurrentIp",
        params
    })
}

//获取系统信息
export let getSysInfo = (params = {}) => {
    return createServe({
        method: "GET",
        url: "/getSysInfo",
        params
    })
}

//获取项目列表
export let getProjectList = (params = {}) => {
    return createServe({
        method: "GET",
        url: "/getProjectList",
        params
    })
}
